import DOMPurify from "dompurify";
import _ from "lodash";
import { arrayOf, shape } from "prop-types";
import { useMemo } from "react";

import __ from "web/Layout/Translations";

import CheckIcon from "web/assets/icons/check.svg";

import formatDate from "web/utils/data/parser/dateAndTime/formatDate";
import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import classify from "web/classify";

import defaultClasses from "./activeFormData.scss";

const CheckoutSubscriptionActiveFormData = ({ classes, data, values }) => {
  const getHeader = (header) => {
    return (
      <strong className={classes.header} key={header.id}>
        {header?.value}
      </strong>
    );
  };

  const getContent = (content) => {
    return (
      <div key={content.id} className="cke_editable">
        <strong className={classes.title}>{content.name}</strong>
        <div className={classes.contentWrapper}>
          {content?.useCheckbox ? (
            <span className={classes.checkbox}>
              {values[content.id] ? (
                <CheckIcon className={classes.icon} />
              ) : null}
            </span>
          ) : null}
          <div
            className={classes.checkboxLabel}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(content?.content),
            }}
          />
        </div>
      </div>
    );
  };

  const getField = (field, id) => {
    let value = _.get(values, field.id);

    if (field.type === "date" || field.type === "birthDate") {
      value = formatDate(value);
    }
    if (field.type === "requirePesel") {
      return (
        <>
          {getField(
            {
              type: "checkbox",
              id: `${field.id}.babyOrForeigner`,
              label: __("Obcokrajowiec / nowonarodzone dziecko"),
            },
            `${id}-babyOrForeigner`
          )}
          {getField(
            { type: "pesel", id: `${field.id}.pesel`, label: __("Pesel") },
            `${id}-babyOrForeigner`
          )}
          {getField(
            {
              type: "birthDate",
              id: `${field.id}.birthDate`,
              label: __("Data urodzenia"),
            },
            `${id}-birthDate`
          )}
        </>
      );
    }
    if (field.type === "checkbox") {
      return (
        <div className={classes.contentWrapper} key={id}>
          <span className={classes.checkbox}>
            {value ? <CheckIcon className={classes.icon} /> : null}
          </span>
          <div
            className={classes.label}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(field.label),
            }}
          />
        </div>
      );
    }
    const currentLabel = field.type === "select" ? field.title : field.label;

    return (
      <dl className={classes.item} key={`${id}`}>
        <dt className={classes.label}>{currentLabel}</dt>
        <dd className={classes.value}>{value || "-"}</dd>
      </dl>
    );
  };

  const formData = useMemo(() => {
    const activeForm = data;

    if (isArrayHasItems(activeForm)) {
      return activeForm.map((section) => {
        if (section.type === "header") {
          return getHeader(section);
        }
        if (section.type === "content") {
          return getContent(section);
        }
        if (section.type === "form") {
          return Object.keys(section.fields).map((key) => {
            return getField(section.fields[key], key);
          });
        }
        return null;
      });
    }

    return null;
  }, [JSON.stringify(data)]);

  return <div className={classes.root}>{formData}</div>;
};
CheckoutSubscriptionActiveFormData.propTypes = {
  classes: shape({}).isRequired,
  values: shape({}).isRequired,
  data: arrayOf(shape({})),
};
CheckoutSubscriptionActiveFormData.defaultProps = {
  data: null,
};

export default classify(defaultClasses)(CheckoutSubscriptionActiveFormData);
